import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { IOuter } from '../EmptyState.types';

export const TrashSubtitle: FC<IOuter> = () => <FormattedMessage id="empty-state.trash-subtitle" />;
